// import React from 'react'

export const makeWebPart = (key, Components) => {
  return Object.keys(Components).reduce((webParts, name) => {
    webParts[`${key}${name}`] = Components[name];
    return webParts
  }, {})
}
